<div class="list-page">
  <app-asiakas-otsikko otsikko="Holvi" paluuUrl="/asiakkaat" [asiakas]="asiakasObservable | async"></app-asiakas-otsikko>
  <div>
    <h3 class="light-blue-text" style="margin-bottom: 30px">Holvi-arkiston lataaminen</h3>
    @if (!tiedostoaLadataan()) {
      <div>
        <div style="margin-bottom: 14px" class="dark-gray-text">
          Työjonossa on {{ kasittelemattomiaObservable | async }} holvitietuetta käsittelemättä
          @if ((kasittelemattomiaObservable | async) > 0 && !(driverObservable | async)) {
            <div class="error-text" style="padding: 3em; font-size: 120%">Ajo näyttää keskeytyneen. Voit käynnistää sen turvallisesti uudelleen tästä: <app-secondary-button (click)="restart()" actionId="Käynnistä Holvin ajo uudelleen" styles="margin-left: 1em;">Käynnistä uudelleen</app-secondary-button></div>
          }
        </div>
        <form>
          <mat-form-field>
            <mat-label>Valitse maksutapa</mat-label>
            <mat-select [formField]="maksutapaLomake.valittu">
              @for (maksutapa of holviMaksutavatObservable | async; track maksutapa) {
                <mat-option [value]="maksutapa">
                  {{ maksutapa.nimi }}
                </mat-option>
              }
            </mat-select>
            @if (onkoVirhe(maksutapaLomake.valittu, 'required') && (maksutapaLomake.valittu().dirty() || maksutapaLomake.valittu().touched())) {
              <mat-error>Maksutapa ei ole valittu. Vain maksutapa, jonka "Kirjauksien muodostus" on "Tuodaan Holvista", voidaan valita. Voit päivittää asetukset napauttamalla "Lemonaid" -> "Maksutavat".</mat-error>
            }
          </mat-form-field>
        </form>
        <div [class.hidden]="!maksutavatLoaded()" class="drag-drop-area">
          <app-file-drop #droppi dropZoneClassName="maksutapa-container" (onFileOver)="fileOver()" (onFileLeave)="fileLeave()" (onFileDrop)="fileDrop($event)" (click)="fileInput.click()" class="droppi" style="cursor: pointer">
            <ng-template app-file-drop-content-tmp>
              <div style="padding: 3em">Vedä tiedosto tähän tai klikkaa</div>
            </ng-template>
          </app-file-drop>
        </div>
        @if (latausvirhe()) {
          <div class="error-box red-text">{{ latausvirhe() }}</div>
        }
        @if (!maksutavatLoaded()) {
          <mat-progress-spinner style="margin-top: 5%" mode="indeterminate"></mat-progress-spinner>
        }
        <div style="font-weight: bold">Sivulta on nyt turvallista navigoida pois.</div>
      </div>
    }
    @if (tiedostoaLadataan()) {
      <div>
        <h2>Ole hyvä ja odota, kunnes lataaminen on valmis.</h2>
        <h3 style="margin-top: 3em">1. Ladataan tiedostoa palvelimelle</h3>
        @if (donePercentageObservable) {
          <mat-progress-bar mode="determinate" [value]="donePercentageObservable | async"></mat-progress-bar>
        }
        @if (tiedostoaKasitellaan()) {
          <h3 style="margin-top: 3em">2. Käsitellään zip-tiedostoa...</h3>
        }
        @if (tiedostoaKasitellaan()) {
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        }
      </div>
    }
  </div>

  @if (holviApiMaksutapaActiveObservable | async) {
    <div style="margin-top: 60px">
      <h3 class="light-blue-text" style="margin: 30px 0">Lataa tilitapahtumat heti kirjanpitoon</h3>
      @if (apiLoadRunning()) {
        <div>Lataus on käynnissä:</div>
      }
      @if (holviApiLoadRunningObservable | async; as apiRunningData) {
        @if (apiLoadRunning()) {
          <div style="padding: 30px">
            @if (!apiRunningData.running) {
              <div>1. Haetaan tietoja Holvin rajapinnasta...</div>
              <div>2. Holvitietojen purku työjonoon odottaa tietojen hakemista.</div>
              <div>3. Tilitapahtumien käsittely odottaa tietojen purkua.</div>
            }
            @if (apiRunningData.running) {
              @if (apiRunningData.holviTransactionsLeft > 0) {
                <div>1. Tietojen haku Holvista on valmis.</div>
              }
              @if (apiRunningData.holviTransactionsLeft > 0) {
                <div>2. Puretaan Holvin tietoja työjonoon, jäljellä {{ apiRunningData.holviTransactionsLeft }}...</div>
              }
              @if (apiRunningData.holviTransactionsLeft > 0) {
                <div>3. Tilitapahtumien käsittely odottaa tietojen purkua, jonossa {{ apiRunningData.transactionsLeft }}.</div>
              }
              @if (1 > apiRunningData.holviTransactionsLeft) {
                <div>1. Tietojen haku Holvista on valmis.</div>
              }
              @if (1 > apiRunningData.holviTransactionsLeft) {
                <div>2. Holvitietojen purku työjonoon valmis.</div>
              }
              @if (1 > apiRunningData.holviTransactionsLeft) {
                <div>3. Käsitellään tilitapahtumia, jäljellä {{ apiRunningData.transactionsLeft }}...</div>
              }
            }
          </div>
        }
      }
      @if (apiLoadRunning()) {
        <div style="padding-bottom: 30px">
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </div>
      }
      @if (!apiLoadRunning()) {
        <form>
          <mat-form-field style="width: 300px; margin-right: 30px">
            <mat-label>Hae tilitapahtumat alkaen</mat-label>
            <input matInput type="text" [matDatepicker]="fetchStartPicker" [formField]="tilitapahtumahakuLomake.start" />
            <mat-datepicker-toggle matSuffix [for]="fetchStartPicker"></mat-datepicker-toggle>
            @if (onkoVirhe(tilitapahtumahakuLomake.start, 'required') && (tilitapahtumahakuLomake.start().dirty() || tilitapahtumahakuLomake.start().touched())) {
              <mat-error> Päivämäärä puuttuu </mat-error>
            }
            @if (onkoVirhe(tilitapahtumahakuLomake.start, 'startBeforeApiEnabled') && (tilitapahtumahakuLomake.start().dirty() || tilitapahtumahakuLomake.start().touched())) {
              <mat-error> Päivämäärä ei saa olla ennen Holvi-yhteyden voimassaolon alkua </mat-error>
            }
            @if (onkoVirhe(tilitapahtumahakuLomake.start, 'endBeforeStart') && (tilitapahtumahakuLomake.start().dirty() || tilitapahtumahakuLomake.start().touched())) {
              <mat-error> Loppupäivämäärä on ennen alkua </mat-error>
            }
          </mat-form-field>
          <mat-datepicker #fetchStartPicker></mat-datepicker>
          <mat-form-field style="width: 300px">
            <mat-label>Hae tilitapahtumat loppuen</mat-label>
            <input matInput type="text" [matDatepicker]="fetchEndPicker" [formField]="tilitapahtumahakuLomake.end" />
            <mat-datepicker-toggle matSuffix [for]="fetchEndPicker"></mat-datepicker-toggle>
            @if (onkoVirhe(tilitapahtumahakuLomake.end, 'required') && (tilitapahtumahakuLomake.end().dirty() || tilitapahtumahakuLomake.end().touched())) {
              <mat-error> Päivämäärä puuttuu </mat-error>
            }
            @if (onkoVirhe(tilitapahtumahakuLomake.end, 'endBeforeStart') && (tilitapahtumahakuLomake.end().dirty() || tilitapahtumahakuLomake.end().touched())) {
              <mat-error> Loppupäivämäärä on ennen alkua </mat-error>
            }
          </mat-form-field>
          <mat-datepicker #fetchEndPicker></mat-datepicker>
        </form>
        @if (fetchError()) {
          <ng-template class="red-rext">{{ fetchError() }}</ng-template>
        }
        <div style="margin-top: 30px">
          <app-primary-button (click)="startHolviTransactionSync()" actionId="Hae Holvi tapahtumat">Hae</app-primary-button>
        </div>
      }
      <div style="margin: 30px 0; font-weight: bold">Historia</div>
      <table style="margin-bottom: 30px">
        @for (log of displayedFetchLogsObservable | async; track log) {
          <tr>
            <td style="width: 150px">{{ log.created | ltimestamptime | async }}</td>
            <td style="width: 120px">{{ log.kirjanpitajanNimi }}</td>
            <td style="width: 80px" [class.red-text]="log.result !== 'success'">{{ log.result === 'success' ? 'Onnistui' : 'Epäonnistui' }}</td>
            <td style="width: 600px">{{ log.extraInfo }}</td>
          </tr>
        }
      </table>
    </div>
  }
</div>

<input #fileInput type="file" style="visibility: hidden" accept="zip,application/zip,application/x-zip,application/x-zip-compressed" (change)="lataa($event)" />
